import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RightPanelType } from '../enums/right-panel-type.enum';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { DetailedTicketDTO } from '../../core/models/dto/detailed-ticket.dto';
import { User } from '@sb-tools/typescript/models/user.model';

@Injectable({ providedIn: 'root' })
export class RightPanelService {
    data: {
        email?: string;
        groupId?: number;
        hidingText?: string;
        replyId?: number;
        ticket?: DetailedTicketDTO;
        user?: User;
        userId?: string;
    };
    isRightPanelOpened = false;
    onToggleRightPanelSubject = new Subject<any>();
    type: RightPanelType;

    constructor(private commonDataService: CommonDataService) {}

    close(): void {
        this.onToggleRightPanelSubject.next(true);

        this.isRightPanelOpened = false;
        this.data = {
            user: null,
        };
    }

    open(type: RightPanelType, data = null): void {
        if (this.commonDataService.user.isReadOnly) {
            return;
        }

        this.onToggleRightPanelSubject.next(true);
        if (this.commonDataService.isOneTime) {
            return;
        }

        this.data = data;
        this.isRightPanelOpened = true;
        this.type = type;
    }
}
